/**
 * sanctions.js — клиент санкций и жалоб на баны.
 *
 * Storys: GET /api-storys/api/v1/storys/me/sanctions
 * Team:   POST /api-team/ban-appeals и др.
 *
 * Используем существующий `request()` из api/client (он шлёт через
 * API_BASE=minecraftia-school.ru с CORS-токеном).
 */
import { request } from "./client";

export async function getMySanctions() {
  try {
    const data = await request(
      "/api-storys/api/v1/storys/me/sanctions",
      { method: "GET", auth: true }
    );
    return data || { sanctions: [], has_active: false };
  } catch {
    return { sanctions: [], has_active: false };
  }
}

export async function getMyAppeals() {
  try {
    const data = await request("/api-team/ban-appeals/my", {
      method: "GET", auth: true,
    });
    return data?.items || [];
  } catch {
    return [];
  }
}

export async function submitAppeal({ banType, banId, banService, text, banSnapshot }) {
  try {
    const data = await request("/api-team/ban-appeals", {
      method: "POST", auth: true,
      body: {
        ban_type: banType, ban_id: banId,
        ban_service: banService || "storys",
        text, ban_snapshot: banSnapshot || null,
      },
    });
    return { ok: true, ...data };
  } catch (e) {
    return { ok: false, message: e?.message || "Не удалось подать жалобу" };
  }
}

export async function getAppeal(appealId) {
  try {
    const data = await request(`/api-team/ban-appeals/${appealId}`, {
      method: "GET", auth: true,
    });
    return { ok: true, ...data };
  } catch (e) {
    return { ok: false, message: e?.message };
  }
}

export async function sendAppealMessage(appealId, text) {
  try {
    const data = await request(`/api-team/ban-appeals/${appealId}/messages`, {
      method: "POST", auth: true, body: { text },
    });
    return { ok: true, ...data };
  } catch (e) {
    return { ok: false, message: e?.message };
  }
}
